
define('template!pimVariationPrintAreaEditTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="pim-vpa-form">\n    <div class="pim-vpa-columns">\n        <div class="pim-vpa-main">\n            <div class="pim-vpa-row">\n                <label class="pim-vpa-field">\n                    <span>' +
__e( _.i18n('common.code', null, 'Code') ) +
' *</span>\n                    <input type="text" class="pim-vpa-input js-field js-code" value="' +
__e( area.code ) +
'" placeholder="RECTO">\n                </label>\n                <label class="pim-vpa-field pim-vpa-field-small">\n                    <span>' +
__e( _.i18n('pim.variationPrintAreas.displayOrder', null, 'Order') ) +
'</span>\n                    <input type="number" class="pim-vpa-input js-field js-display-order" value="' +
__e( area.displayOrder ) +
'">\n                </label>\n            </div>\n\n            <div class="pim-vpa-row">\n                ';
 _.each(languages, function (lang) { ;
__p += '\n                <label class="pim-vpa-field">\n                    <span>' +
__e( _.i18n('common.name', null, 'Name') ) +
' (' +
__e( lang.toUpperCase() ) +
')</span>\n                    <input type="text" class="pim-vpa-input js-field js-name" data-lang="' +
__e( lang ) +
'" value="' +
__e( area.name.values[lang] || '' ) +
'">\n                </label>\n                ';
 }) ;
__p += '\n            </div>\n\n            <div class="pim-vpa-row">\n                <label class="pim-vpa-field pim-vpa-field-small">\n                    <span>' +
__e( _.i18n('common.width', null, 'Width') ) +
' (mm) *</span>\n                    <input type="number" min="0" step="0.1" class="pim-vpa-input js-field js-width" value="' +
__e( area.width === null || area.width === undefined ? '' : area.width ) +
'">\n                </label>\n                <label class="pim-vpa-field pim-vpa-field-small">\n                    <span>' +
__e( _.i18n('common.height', null, 'Height') ) +
' (mm) *</span>\n                    <input type="number" min="0" step="0.1" class="pim-vpa-input js-field js-height" value="' +
__e( area.height === null || area.height === undefined ? '' : area.height ) +
'">\n                </label>\n                <div class="pim-vpa-help">' +
__e( _.i18n('pim.variationPrintAreas.formatHint', null, 'Finished format (trim), without the bleed.') ) +
'</div>\n            </div>\n\n            ';
 _.each(borders, function (key) { ;
__p += '\n            <div class="pim-vpa-row pim-vpa-border">\n                <div class="pim-vpa-border-title">\n                    <span class="pim-vpa-swatch ' +
((__t = ( key === 'lostBorder' ? 'pim-vpa-swatch-lost' : 'pim-vpa-swatch-safe' )) == null ? '' : __t) +
'"></span>\n                    ';
 if (key === 'lostBorder') { ;
__p += '\n                    ' +
__e( _.i18n('pim.variationPrintAreas.lostBorder', null, 'Bleed') ) +
'\n                    ';
 } else { ;
__p += '\n                    ' +
__e( _.i18n('pim.variationPrintAreas.securityBorder', null, 'Security border') ) +
'\n                    ';
 } ;
__p += '\n                    (mm)\n                </div>\n                ';
 if (uniform[key]) { ;
__p += '\n                <label class="pim-vpa-field pim-vpa-field-small">\n                    <span>' +
__e( _.i18n('pim.variationPrintAreas.allSides', null, 'All sides') ) +
'</span>\n                    <input type="number" min="0" step="0.1" class="pim-vpa-input js-field js-border-all" data-border="' +
__e( key ) +
'" value="' +
__e( area[key].top ) +
'">\n                </label>\n                ';
 } else { ;
__p += '\n                ';
 _.each(sides, function (side) { ;
__p += '\n                <label class="pim-vpa-field pim-vpa-field-small">\n                    <span>' +
__e( _.i18n('pim.variationPrintAreas.side.' + side, null, side.charAt(0).toUpperCase() + side.substring(1)) ) +
'</span>\n                    <input type="number" min="0" step="0.1" class="pim-vpa-input js-field js-border-side" data-border="' +
__e( key ) +
'" data-side="' +
__e( side ) +
'" value="' +
__e( area[key][side] ) +
'">\n                </label>\n                ';
 }) ;
__p += '\n                ';
 } ;
__p += '\n                <label class="pim-vpa-check">\n                    <input type="checkbox" class="js-uniform" data-border="' +
__e( key ) +
'" ' +
((__t = ( uniform[key] ? 'checked' : '' )) == null ? '' : __t) +
'>\n                    ' +
__e( _.i18n('pim.variationPrintAreas.sameOnAllSides', null, 'Same on all sides') ) +
'\n                </label>\n            </div>\n            ';
 }) ;
__p += '\n        </div>\n\n        <div class="pim-vpa-drawing js-drawing"></div>\n    </div>\n\n    <div class="pim-vpa-block">\n        <div class="pim-vpa-block-title">\n            ' +
__e( _.i18n('pim.variationPrintAreas.appliesTo', null, 'Applies to') ) +
'\n            <button type="button" class="btn-vpa-small js-add-rule">' +
__e( _.i18n('pim.variationPrintAreas.addRule', null, 'Add a rule') ) +
'</button>\n        </div>\n        <div class="pim-vpa-help">' +
__e( _.i18n('pim.variationPrintAreas.rulesHint', null, 'A variation matches when one rule matches all the steps it sets. No rule and no extra code: every variation.') ) +
'</div>\n        ';
 _.each(area.appliesTo, function (rule, index) { ;
__p += '\n        <div class="pim-vpa-rule js-rule" data-index="' +
((__t = ( index )) == null ? '' : __t) +
'">\n            ';
 _.each(steps, function (step) { var value = rule[step.code] || ''; ;
__p += '\n            <label class="pim-vpa-field">\n                <span>' +
__e( step.name ) +
'</span>\n                <select class="pim-vpa-input js-field js-rule-cat" data-cat="' +
__e( step.code ) +
'">\n                    <option value="" ' +
((__t = ( value === '' ? 'selected' : '' )) == null ? '' : __t) +
'>— ' +
__e( _.i18n('pim.variationPrintAreas.notUsed', null, 'not used') ) +
' —</option>\n                    <option value="' +
__e( any ) +
'" ' +
((__t = ( value === any ? 'selected' : '' )) == null ? '' : __t) +
'>' +
__e( _.i18n('pim.variationPrintAreas.any', null, 'Any') ) +
'</option>\n                    ';
 _.each(step.options, function (option) { ;
__p += '\n                    <option value="' +
__e( option.code ) +
'" ' +
((__t = ( value === option.code ? 'selected' : '' )) == null ? '' : __t) +
'>' +
__e( option.name ) +
'' +
__e( option.name !== option.code ? ' (' + option.code + ')' : '' ) +
'</option>\n                    ';
 }) ;
__p += '\n                    ';
 if (value && value !== any && !_.findWhere(step.options, {code: value})) { ;
__p += '\n                    <option value="' +
__e( value ) +
'" selected>' +
__e( value ) +
' (' +
__e( _.i18n('pim.variationPrintAreas.unknown', null, 'unknown') ) +
')</option>\n                    ';
 } ;
__p += '\n                </select>\n            </label>\n            ';
 }) ;
__p += '\n            ';
 _.each(unknown[index], function (cat) { ;
__p += '\n            <label class="pim-vpa-field pim-vpa-unknown">\n                <span>' +
__e( cat ) +
' (' +
__e( _.i18n('pim.variationPrintAreas.unknown', null, 'unknown') ) +
')</span>\n                <select class="pim-vpa-input js-field js-rule-cat" data-cat="' +
__e( cat ) +
'">\n                    <option value="' +
__e( rule[cat] ) +
'" selected>' +
__e( rule[cat] ) +
'</option>\n                    <option value="">— ' +
__e( _.i18n('common.delete', null, 'Delete') ) +
' —</option>\n                </select>\n            </label>\n            ';
 }) ;
__p += '\n            <i class="mdi-action-delete clickable js-remove-rule" title="' +
__e( _.i18n('pim.variationPrintAreas.removeRule', null, 'Remove this rule') ) +
'"></i>\n        </div>\n        ';
 }) ;
__p += '\n\n        <label class="pim-vpa-field pim-vpa-field-wide">\n            <span>' +
__e( _.i18n('pim.variationPrintAreas.variationCodes', null, 'Extra variation codes (comma separated)') ) +
'</span>\n            <textarea rows="2" class="pim-vpa-input js-field js-variation-codes">' +
__e( variationCodesText ) +
'</textarea>\n        </label>\n\n        <div class="pim-vpa-preview">\n            <button type="button" class="btn-vpa-small js-preview">' +
__e( _.i18n('pim.variationPrintAreas.check', null, 'Check') ) +
'</button>\n            ';
 if (preview && preview.loading) { ;
__p += '\n            <span class="pim-vpa-muted">' +
__e( _.i18n('common.loading', null, 'Loading...') ) +
'</span>\n            ';
 } else if (preview) { ;
__p += '\n            <strong>' +
__e( preview.count ) +
' ' +
__e( _.i18n('pim.variationPrintAreas.variations', null, 'variations') ) +
'</strong>\n            <span class="pim-vpa-muted">\n                ' +
__e( preview.codes.slice(0, previewCodesShown).join(', ') ) +
'' +
__e( preview.count > previewCodesShown ? ', …' : '' ) +
'\n            </span>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n\n    <div class="pim-vpa-block">\n        <div class="pim-vpa-block-title">\n            ' +
__e( _.i18n('pim.variationPrintAreas.techniques', null, 'Techniques') ) +
' *\n            <button type="button" class="btn-vpa-small js-add-zone">' +
__e( _.i18n('pim.variationPrintAreas.addTechnique', null, 'Add a technique') ) +
'</button>\n        </div>\n        ';
 _.each(zones, function (zone, index) { ;
__p += '\n        <div class="pim-vpa-zone js-zone" data-index="' +
((__t = ( index )) == null ? '' : __t) +
'">\n            <label class="pim-vpa-field pim-vpa-field-small">\n                <span>' +
__e( _.i18n('common.code', null, 'Code') ) +
' *</span>\n                <input type="text" class="pim-vpa-input js-field js-zone-code" value="' +
__e( zone.code ) +
'" placeholder="QUADRI">\n            </label>\n            <label class="pim-vpa-field">\n                <span>' +
__e( _.i18n('common.name', null, 'Name') ) +
'</span>\n                <input type="text" class="pim-vpa-input js-field js-zone-name" value="' +
__e( zone.name ) +
'">\n            </label>\n            <label class="pim-vpa-field pim-vpa-field-small">\n                <span>' +
__e( _.i18n('pim.variationPrintAreas.colorMode', null, 'Colour mode') ) +
'</span>\n                <select class="pim-vpa-input js-field js-zone-mode">\n                    ';
 _.each(colorModes, function (mode) { ;
__p += '\n                    <option value="' +
__e( mode ) +
'" ' +
((__t = ( zone.colorModeType === mode ? 'selected' : '' )) == null ? '' : __t) +
'>' +
__e( mode ) +
'</option>\n                    ';
 }) ;
__p += '\n                </select>\n            </label>\n            <label class="pim-vpa-field pim-vpa-field-small">\n                <span>' +
__e( _.i18n('pim.variationPrintAreas.maxColors', null, 'Max colours') ) +
'</span>\n                <input type="number" min="0" class="pim-vpa-input js-field js-zone-max" value="' +
__e( zone.maxColors ) +
'">\n            </label>\n            <label class="pim-vpa-check">\n                <input type="radio" name="pim-vpa-default-zone" class="js-field js-zone-default" value="' +
((__t = ( index )) == null ? '' : __t) +
'" ' +
((__t = ( zone.isDefault ? 'checked' : '' )) == null ? '' : __t) +
'>\n                ' +
__e( _.i18n('pim.variationPrintAreas.default', null, 'default') ) +
'\n            </label>\n            <i class="mdi-action-delete clickable js-remove-zone" title="' +
__e( _.i18n('pim.variationPrintAreas.removeTechnique', null, 'Remove this technique') ) +
'"></i>\n        </div>\n        ';
 }) ;
__p += '\n        ';
 if (!zones.length) { ;
__p += '\n        <div class="pim-vpa-error">' +
__e( _.i18n('pim.variationPrintAreas.noTechnique', null, 'At least one technique is required.') ) +
'</div>\n        ';
 } ;
__p += '\n    </div>\n\n    ';
 if (error) { ;
__p += '\n    <div class="pim-vpa-error">' +
__e( error ) +
'</div>\n    ';
 } ;
__p += '\n\n    <div class="pim-vpa-footer">\n        <button type="button" class="btn btn-default js-cancel">' +
__e( _.i18n('common.cancel', null, 'Cancel') ) +
'</button>\n        <button type="button" class="btn btn-primary js-save" ' +
((__t = ( busy ? 'disabled' : '' )) == null ? '' : __t) +
'>' +
__e( _.i18n('common.save', null, 'Save') ) +
'</button>\n    </div>\n</div>\n';

}
return __p
};});

